// assets
import { DashboardOutlined, ProjectOutlined, FileTextOutlined, MessageOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  ProjectOutlined,
  FileTextOutlined,
  MessageOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'projects',
      title: 'Projects',
      type: 'item',
      url: '/projects',
      icon: icons.ProjectOutlined,
      breadcrumbs: false
    },
    {
      id: 'blog-post',
      title: 'Blog post',
      type: 'item',
      url: '/blog-post',
      icon: icons.FileTextOutlined,
      breadcrumbs: false
    },
    {
      id: 'testimonial',
      title: 'Testimonial',
      type: 'item',
      url: '/testimonial',
      icon: icons.MessageOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
